import { api } from '@cma/app'
import { RequestResetPasswordMutation } from '@cma/generated/graphql'
import { useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'

interface RequestResetPasswordVariables {
  email: string
  accountId?: string
}

export function useRequestResetPassword() {
  return useMutation<
    RequestResetPasswordMutation,
    Error,
    RequestResetPasswordVariables
  >(({ email, accountId }) => {
    const query = gql`
      mutation RequestResetPassword($email: String!, $accountId: ID) {
        requestResetPassword(email: $email, accountId: $accountId)
      }
    `
    const variables = { email, accountId }
    return api<RequestResetPasswordMutation>({ query, variables })
  })
}
